<template>
  <div class="app">
    <Head></Head>
    <div class="pc" v-if="isPhone==false">
      <div class="container1">
        <div v-if="section1Type==0" @click="changeSection1Type()" class="clickStyle">
          <img alt="xxx" src="../../static/viloran-drive/video/001.jpg" style="width: 100%;" />
        </div>
        <div v-if="section1Type==1">
          <video class="video" muted autoplay="autoplay" loop="loop" controls="controls">
            <source :src="sec1VideoUrl" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="container2">
        <div class="content">
          <div class="left">
            <div class="img">
              <img alt="xxx" :src="spotImg" style="width: 100%;" />
            </div>
            <div id="spot1" class="spot1" @click="changeSpot1()"></div>
            <div id="spot2" class="spot2" @click="changeSpot2()"></div>
            <div id="spot3" class="spot3" @click="changeSpot3()"></div>
          </div>
          <div class="right">
            <div class="title">Viloran威然品评会</div>
            <div class="line"></div>
            <div class="text">作为上汽大众首款大型豪华商务MPV，Viloran威然不久前耀目上市，众媒体大咖纷纷试驾，带你感受豪华“威”力，来听听他们怎么说。</div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
      <div class="container3">
        <div class="title">
          <div class="img">
            <img alt="xxx" src="../../assets/viloran-drive/imgs/302.png" style="width:100%" />
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="contain">
              <div class="list">
                <div class="item" id="item-select1" @click="sec2Click(1)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3101.png" />
                  </div>
                  <div class="text">大尺寸格栅基于大众最新的家族式设计打造，横向镀铬条增加了车头的视觉宽度。</div>
                  <div class="jumpWei" @click="jumpWei(1)">查看原文></div>
                </div>
                <div class="item" id="item-select2" @click="sec2Click(2)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3102.png" />
                  </div>
                  <div class="text">行李厢空间的优势非常明显。即便在7人满座状态下，大众威然的载物空间仍然非常可观。</div>
                  <div class="jumpWei" @click="jumpWei(2)">查看原文></div>
                </div>
                <div class="item" id="item-select3" @click="sec2Click(3)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3103.png" />
                  </div>
                  <div
                    class="text"
                  >新车的材质则更加符合这台车的调性，比方说一些棕色的主色调，以及这些木纹饰板和铝合金饰板，除了观感很不错，触感也很好，确实营造了一份高雅感。</div>
                  <div class="jumpWei" @click="jumpWei(3)">查看原文></div>
                </div>
                <div class="item" id="item-select4" @click="sec2Click(4)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3104.png" />
                  </div>
                  <div class="text">威然的车身设计并没有采用大众传统方盒子风格设计，反而更加具有流线条风格，这也使得新车在众多商务MPV产品当中显得独树一帜。</div>
                  <div class="jumpWei" @click="jumpWei(4)">查看原文></div>
                </div>
<!--                <div class="item" id="item-select5" @click="sec2Click(5)">-->
<!--                  <div class="title">-->
<!--                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3105.png" />-->
<!--                  </div>-->
<!--                  <div-->
<!--                    class="text"-->
<!--                  >Viloran给我的第一印象就是大，结合实际的车身尺寸来看，它就是真的大。Viloran的长宽高分别为5346mm/1976mm/1781mm，轴距为3180。</div>-->
<!--                  <div class="jumpWei" @click="jumpWei(5)">查看原文></div>-->
<!--                </div>-->
                <div class="item" id="item-select6" @click="sec2Click(6)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3106.png" />
                  </div>
                  <div
                    class="text"
                  >大众设计师还是很细心，在前排座椅的背后不仅设计了一个大的储物袋，在上半部分还专门设计了两个小的储物袋，适合放手机、笔记本一类的小东西。</div>
                  <div class="jumpWei" @click="jumpWei(6)">查看原文></div>
                </div>
                <div class="item" id="item-select7" @click="sec2Click(7)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3107.png" />
                  </div>
                  <div
                    class="text"
                  >Viloran威然以“新商务”为灵感，演绎全新设计美学，打破商务车方正刻板的传统形象，用刚柔并济的设计理念演绎新商务风范，引领商务美学的新风潮。</div>
                  <div class="jumpWei" @click="jumpWei(7)">查看原文></div>
                </div>
                <div class="item" id="item-select8" @click="sec2Click(8)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3108.png" />
                  </div>
                  <div
                    class="text"
                  >Captain Chair行政级第二排高档真皮打孔礼宾座椅采用菱形格纹理，辅以滚边与绗缝工艺，再加上双侧电动侧滑移门和豪华立体门饰板， 更精致也更显档次感。</div>
                  <div class="jumpWei" @click="jumpWei(8)">查看原文></div>
                </div>
                <div class="item" id="item-select9" @click="sec2Click(9)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3109.png" />
                  </div>
                  <div
                    class="text"
                  >第三排座椅的乘坐姿势非常舒适，对于那些身高体重较大的人来说，同样能够保持一个舒适的坐姿，加以超大全景天窗的配备，在后排丝毫没有压抑感。</div>
                  <div class="jumpWei" @click="jumpWei(9)">查看原文></div>
                </div>
                <div class="item" id="item-select10" @click="sec2Click(10)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3110.png" />
                  </div>
                  <div
                    class="text"
                  >能让木纹饰板、镀铬饰条、钢琴烤漆这些昔日很常见的元素交织在一起，有档次，却又不落俗套，不得不说，Viloran的内饰设计是很成功的。</div>
                  <div class="jumpWei" @click="jumpWei(10)">查看原文></div>
                </div>
                <div class="item" id="item-select11" @click="sec2Click(11)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3111.png" />
                  </div>
                  <div class="text">大面积镀铬格栅和大灯融为一体，尾部的车灯系统IQ Light也是细节十足，特别是在夜晚点亮后效果十分炸裂。</div>
                  <div class="jumpWei" @click="jumpWei(11)">查看原文></div>
                </div>
                <div class="item" id="item-select12" @click="sec2Click(12)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3112.png" />
                  </div>
                  <div class="text">尾灯组采用了扁平化且修长的设计，另外再加上贯穿式的镀铬装饰，给人一种十分精致的感觉。尾部排气管则是双边共两出的扁平化设计。</div>
                  <div class="jumpWei" @click="jumpWei(12)">查看原文></div>
                </div>
                <div class="item" id="item-select13" @click="sec2Click(13)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3113.png" />
                  </div>
                  <div
                    class="text"
                  >10.25英寸的全液晶仪表为全系标配，界面是目前大众的最新风格，并且带有三种显示效果，切换到地图菜单后，整个屏幕将会被地图充斥，省去了歪头看中控屏的动作，便利性不错。</div>
                  <div class="jumpWei" @click="jumpWei(13)">查看原文></div>
                </div>
                <div class="item" id="item-select101" @click="sec2Click(101)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3101.png" />
                  </div>
                  <div
                    class="text"
                  >全新的9.2英寸屏智联系统提供了包括在线导航、组队出行、网络音乐+电台在内的诸多在线服务功能，基础流量免费，用车初期上汽大众还将赠送娱乐流量和Wi-Fi热点流量。</div>
                  <div class="jumpWei" @click="jumpWei(101)">查看原文></div>
                </div>
                <div class="item" id="item-select201" @click="sec2Click(201)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3102.png" />
                  </div>
                  <div
                    class="text"
                  >作为上汽大众旗下高端MPV，这台顶配车型功能上自然也毫不含糊，全LED大灯（带自适应远/近光功能）、360°全景影像系统、全车无钥匙进入功能、后排电滑门、全车双层玻璃/后排隐私玻璃、ACC自适应巡航、电动尾门等，这样的配置也符合豪华商务MPV车主们的真实需求。</div>
                  <div class="jumpWei" @click="jumpWei(201)">查看原文></div>
                </div>
                <div class="item" id="item-select14" @click="sec2Click(14)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3114.png" />
                  </div>
                  <div
                    class="text"
                  >值得一提的是，采用人体工程学设计的双贵宾行政座椅，配备了头等舱座椅中央扶手，头枕采用航空睡眠头枕，不仅支持不同高度调节，还特别增加了头枕侧翼角度调节功能，提高对乘员头部的包裹性和支撑度，从而提高乘坐舒适性。</div>
                  <div class="jumpWei" @click="jumpWei(14)">查看原文></div>
                </div>
                <div class="item" id="item-select15" @click="sec2Click(15)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3115.png" />
                  </div>
                  <div class="text">两张行政级的独立座椅都能给到你贵宾级的享受，腿托高度、靠背角度都是电动调节，另外还有加热/通风和按摩功能可用。</div>
                  <div class="jumpWei" @click="jumpWei(15)">查看原文></div>
                </div>
                <div class="item" id="item-select16" @click="sec2Click(16)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3116.png" />
                  </div>
                  <div
                    class="text"
                  >在扶手内侧，设有一处推拉式的水杯架和手机支架，值得一提的是，在手机支架下部还设有一处导线槽，避免了可以架手机但不能插线的尴尬，设计非常贴心。</div>
                  <div class="jumpWei" @click="jumpWei(16)">查看原文></div>
                </div>
                <div class="item" id="item-select17" @click="sec2Click(17)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3117.png" />
                  </div>
                  <div
                    class="text"
                  >Viloran威然使用了柔性副车架以及纵向摆臂液压支撑，并采用超过77%的高强度钢（其中65%为热成形及超高强度钢）、近7米的激光焊接、双面镀锌和空腔注蜡防锈腐工艺，充分保证驾乘人员的安全。</div>
                  <div class="jumpWei" @click="jumpWei(17)">查看原文></div>
                </div>
                <div class="item" id="item-select18" @click="sec2Click(18)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3118.png" />
                  </div>
                  <div
                    class="text"
                  >威然在设计之初还充分考虑了高端豪华MPV对于座舱静谧性的需求，从车身设计、车体隔音材料以及整车调教等60多处隔音降噪措施，全面提升噪音隔绝与吸收能力。</div>
                  <div class="jumpWei" @click="jumpWei(18)">查看原文></div>
                </div>
                <div class="item" id="item-select19" @click="sec2Click(19)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3119.png" />
                  </div>
                  <div
                    class="text"
                  >威然支持自动刹停和起步，同时起步加速和刹停的力度非常柔和，不会有一惊一乍的耸动感。</div>
                  <div class="jumpWei" @click="jumpWei(19)">查看原文></div>
                </div>
                <div class="item" id="item-select20" @click="sec2Click(20)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3120.png" />
                  </div>
                  <div
                    class="text"
                  >本次试驾车型还提供齐全的驾驶辅助装置，包括ACC自适应巡航、车道保持辅助、变道辅助等，长途出游或者拥堵路况下行驶都能够减轻驾驶员的疲惫感。</div>
                  <div class="jumpWei" @click="jumpWei(20)">查看原文></div>
                </div>
                <div class="item" id="item-select21" @click="sec2Click(21)">
                  <div class="title">
                    <img alt="xxx" src="../../assets/viloran-drive/imgs/3121.png" />
                  </div>
                  <div
                    class="text"
                  >虽然在威然若大的引擎舱里，发动机显得格外“紧凑”，但这台高功率的EA888发动机匹配7速双离合变速器，动力表现真的有惊喜，实测百公里加速仅为8.8秒左右。</div>
                  <div class="jumpWei" @click="jumpWei(21)">查看原文></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="img">
              <img alt="xxx" :src="sec2RightPic" style="width: 100%;" />
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div class="container4">
        <div class="title">
          <div class="img">
            <img alt="xxx" src="../../assets/viloran-drive/imgs/401.png" style="width:100%" />
          </div>
        </div>
        <div class="content">
          <table>
            <tr>
              <td class="img clickStyle">
                <div v-if="imgData.type==0" @click="showPop(imgData.url1)">
                  <img alt="xxx" :src="imgData.url1" style="width: 100%;" />
                </div>
                <div v-if="imgData.type==1||imgData.type==2" @click="playVideo1(imgData)">
                  <img alt="xxx" :src="imgData.url1" style="width: 100%;" />
                </div>
              </td>
              <td class="img clickStyle">
                <div v-if="imgData.type==0||imgData.type==2" @click="showPop(imgData.url2)">
                  <img alt="xxx" :src="imgData.url2" style="width: 100%;" />
                </div>
                <div v-if="imgData.type==1" @click="playVideo2(imgData)">
                  <img alt="xxx" :src="imgData.url2" style="width: 100%;" />
                </div>
              </td>
              <td class="img clickStyle" @click="showPop(imgData.url3)">
                <img alt="xxx" :src="imgData.url3" style="width: 100%;" />
              </td>
              <td class="img clickStyle" @click="showPop(imgData.url4)">
                <img alt="xxx" :src="imgData.url4" style="width: 100%;" />
              </td>
            </tr>
          </table>
          <div id="leftClick" class="left clickStyle" @click="changeLeft()">
            <img alt="xxx" src="../../assets/viloran-drive/imgs/402.png" style="width: 100%;" />
          </div>
          <div id="rightClick" class="right clickStyle" @click="changeRight()">
            <img alt="xxx" src="../../assets/viloran-drive/imgs/403.png" style="width: 100%;" />
          </div>
        </div>
        <div class="cover" v-if="showCover"></div>
        <div class="popup" v-if="showCover">
          <div>
            <div class="close" @click="closePop()">
              <img alt="xxx" src="../../assets/viloran-drive/imgs/106.png" style="width: 100%;" />
            </div>

            <div class="img">
              <div v-if="this.popUrl!=null">
                <img alt="xxx" :src="popUrl" style="width: 100%;" />
              </div>
              <div v-if="this.popUrl==null">
                <video style="width:100%" muted autoplay="autoplay" loop="loop" controls="controls">
                  <source :src="videoUrl" type="video/mp4" />
                </video>
              </div>
            </div>
            <div id="leftClickPop" class="left clickStyle" @click="changeLeftPop()">
              <img alt="xxx" src="../../assets/viloran-drive/imgs/402.png" style="width: 100%;" />
            </div>
            <div id="rightClickPop" class="right clickStyle" @click="changeRightPop()">
              <img alt="xxx" src="../../assets/viloran-drive/imgs/403.png" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViloranDriveMobile v-if="isPhone"></ViloranDriveMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import ViloranDriveMobile from "./ViloranDriveMobile";
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
import {
  viloran_dirve_001,
  viloran_dirve_401,
  viloran_dirve_402,
} from "../../components/config";
export default {
  name: "ViloranDrive",
  components: {
    ViloranDriveMobile,
    Head,
    Foot,
  },
  data() {
    return {
      isPhone: false,
      sec1VideoUrl: viloran_dirve_001,
      section1Type: 0,
      picIndex: 0,
      sec2RightPic: require("../../assets/viloran-drive/imgs/3201.jpg"),
      imgData: {
        type: 1,
        url1: require("../../static/viloran-drive/video/403.jpg"),
        video1: viloran_dirve_401,
        url2: require("../../static/viloran-drive/video/404.jpg"),
        video2: viloran_dirve_402,
        url3: require("../../assets/viloran-drive/imgs/411.jpg"),
        url4: require("../../assets/viloran-drive/imgs/412.jpg"),
      },
      spotImg: require("../../assets/viloran-drive/imgs/204.jpg"),
      showCover: false,
      popUrl: require("../../assets/viloran-drive/imgs/411.jpg"),
      popPicIndex: 0,
      popPicArr: [
        {
          popPicIndex: 1,
          url: viloran_dirve_401,
        },
        {
          popPicIndex: 2,
          url: viloran_dirve_402,
        },
        {
          popPicIndex: 3,
          url: require("../../assets/viloran-drive/imgs/411.jpg"),
        },
        {
          popPicIndex: 4,
          url: require("../../assets/viloran-drive/imgs/412.jpg"),
        },
        {
          popPicIndex: 5,
          url: require("../../assets/viloran-drive/imgs/413.jpg"),
        },
        {
          popPicIndex: 6,
          url: require("../../assets/viloran-drive/imgs/414.jpg"),
        },
        {
          popPicIndex: 7,
          url: require("../../assets/viloran-drive/imgs/415.jpg"),
        },
        {
          popPicIndex: 8,
          url: require("../../assets/viloran-drive/imgs/416.jpg"),
        },
        {
          popPicIndex: 9,
          url: require("../../assets/viloran-drive/imgs/417.jpg"),
        },
        {
          popPicIndex: 10,
          url: require("../../assets/viloran-drive/imgs/418.jpg"),
        },
        {
          popPicIndex: 11,
          url: require("../../assets/viloran-drive/imgs/419.jpg"),
        },
        {
          popPicIndex: 12,
          url: require("../../assets/viloran-drive/imgs/4110.jpg"),
        },
        {
          popPicIndex: 13,
          url: require("../../assets/viloran-drive/imgs/4111.jpg"),
        },
        {
          popPicIndex: 14,
          url: require("../../assets/viloran-drive/imgs/4112.jpg"),
        },
        {
          popPicIndex: 15,
          url: require("../../assets/viloran-drive/imgs/4113.jpg"),
        },
        {
          popPicIndex: 16,
          url: require("../../assets/viloran-drive/imgs/4114.jpg"),
        },
        {
          popPicIndex: 17,
          url: require("../../assets/viloran-drive/imgs/4115.jpg"),
        },
      ],
    };
  },
  mounted: function () {
    // 判断是否手机
    this.getIsPhone();
    this.contain2Init();
    this.sec2Click(1);
    this.setTitle();
  },
  methods: {
    changeSection1Type() {
      this.section1Type = 1;
    },
    contain2Init() {
      let index = 1;
      setInterval(() => {
        if (index > 3) {
          index = 1;
        }
        if (index == 1) {
          this.changeSpot1();
        } else if (index == 2) {
          this.changeSpot2();
        } else if (index == 3) {
          this.changeSpot3();
        }
        index++;
      }, 3000);
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "威然试驾";
    },
    changeSpot1() {
      this.spotImg = require("../../assets/viloran-drive/imgs/204.jpg");
      document.getElementById("spot1").style.opacity = 1;
      document.getElementById("spot2").style.opacity = 0.4;
      document.getElementById("spot3").style.opacity = 0.4;
    },
    changeSpot2() {
      this.spotImg = require("../../assets/viloran-drive/imgs/205.jpg");
      document.getElementById("spot1").style.opacity = 0.4;
      document.getElementById("spot2").style.opacity = 1;
      document.getElementById("spot3").style.opacity = 0.4;
    },
    changeSpot3() {
      this.spotImg = require("../../assets/viloran-drive/imgs/206.jpg");
      document.getElementById("spot1").style.opacity = 0.4;
      document.getElementById("spot2").style.opacity = 0.4;
      document.getElementById("spot3").style.opacity = 1;
    },
    sec2Click(type) {
      if (type == 1) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3201.jpg");
      } else if (type == 101) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/32012.jpg");
      } else if (type == 201) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/32022.jpg");
      } else if (type == 2) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3202.jpg");
      } else if (type == 3) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3203.jpg");
      } else if (type == 4) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3204.jpg");
      } else if (type == 5) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3205.jpg");
      } else if (type == 6) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3206.jpg");
      } else if (type == 7) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3207.jpg");
      } else if (type == 8) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3208.jpg");
      } else if (type == 9) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3209.jpg");
      } else if (type == 10) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3210.jpg");
      } else if (type == 11) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3211.jpg");
      } else if (type == 12) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3212.jpg");
      } else if (type == 13) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3213.jpg");
      } else if (type == 14) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3214.jpg");
      } else if (type == 15) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3215.jpg");
      } else if (type == 16) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3216.jpg");
      } else if (type == 17) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3217.jpg");
      } else if (type == 18) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3218.jpg");
      } else if (type == 19) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3219.jpg");
      } else if (type == 20) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3220.jpg");
      } else if (type == 21) {
        this.sec2RightPic = require("../../assets/viloran-drive/imgs/3221.jpg");
      }
      // 先清除样式
      for (var i = 1; i < 22; i++) {
        document.getElementById("item-select" + i + "").style.background = "";
      }
      document.getElementById("item-select101").style.background = "";
      document.getElementById("item-select201").style.background = "";
      // 再加上样式
      document.getElementById("item-select" + type + "").style.background =
        "rgba(255, 255, 255, 0.3)";
    },
    jumpWei(type) {
      if (type == 1) {
        window.open(
          "https://www.autohome.com.cn/drive/202004/989585.html",
          "_blank"
        );
      } else if (type == 2) {
        window.open(
          "https://new.qq.com/omn/AUT20200/AUT2020051401367600",
          "_blank"
        );
      } else if (type == 3) {
        window.open(
          "https://www.pcauto.com.cn/pingce/2043/20431199.html",
          "_blank"
        );
      } else if (type == 4) {
        window.open(
          "https://chejiahao.autohome.com.cn/info/6092342#pvareaid=28086820716",
          "_blank"
        );
      } else if (type == 5) {
        window.open("http://auto.fjsen.com/news/storys_143887.html", "_blank");
      } else if (type == 6) {
        window.open(
          "https://new.qq.com/omn/20200511/20200511A09TLA00",
          "_blank"
        );
      } else if (type == 7) {
        window.open(
          "http://inf.315che.com/che_v3/newsdetail/detail?newsid=1969550&adddate=2020_05&preview=1&contentPage=2",
          "_blank"
        );
      } else if (type == 8) {
        window.open(
          "https://chejiahao.autohome.com.cn/info/6088868#pvareaid=6838848",
          "_blank"
        );
      } else if (type == 9) {
        window.open(
          "http://www.chooseauto.com.cn/shijia/ceshi/305582.shtml",
          "_blank"
        );
      } else if (type == 10) {
        window.open(
          "http://auto.news18a.com/news/storys_143887.html",
          "_blank"
        );
      } else if (type == 11) {
        window.open(
          "https://chejiahao.autohome.com.cn/info/6183036#pvareaid=28086820716",
          "_blank"
        );
      } else if (type == 12) {
        window.open("http://news.bitauto.com/hao/wenzhang/33500442", "_blank");
      } else if (type == 13) {
        window.open(
          "https://auto.sina.com.cn/newcar/x/2020-05-15/detail-iircuyvi3110778.shtml",
          "_blank"
        );
      } else if (type == 101) {
        window.open(
          "https://www.autohome.com.cn/drive/202004/989585.html",
          "_blank"
        );
      } else if (type == 201) {
        window.open(
          "https://new.qq.com/omn/AUT20200/AUT2020051401367600",
          "_blank"
        );
      } else if (type == 14) {
        window.open(
          "http://k.sina.com.cn/article_2506770970_956a4a1a00100ry8q.html",
          "_blank"
        );
      } else if (type == 15) {
        window.open("https://m.youcheyihou.com/news/477294", "_blank");
      } else if (type == 16) {
        window.open("http://www.niuche.com/news/detail_520971.html", "_blank");
      } else if (type == 17) {
        window.open("https://chejiahao.autohome.com.cn/info/6135298", "_blank");
      } else if (type == 18) {
        window.open(
          "https://new.qq.com/omn/20200507/20200507A0HSDX00",
          "_blank"
        );
      } else if (type == 19) {
        window.open("https://www.toutiao.com/i6827719810831352327/", "_blank");
      } else if (type == 20) {
        window.open("https://chejiahao.autohome.com.cn/info/6092072", "_blank");
      } else if (type == 21) {
        window.open(
          "https://new.qq.com/omn/20200519/20200519A0H22W00",
          "_blank"
        );
      }
    },
    changeLeft() {
      if (this.picIndex > 0) {
        this.picIndex--;
        document.getElementById("leftClick").style.opacity = 1;
      } else {
        this.picIndex = 0;
        document.getElementById("leftClick").style.opacity = 0.4;
      }
      document.getElementById("rightClick").style.opacity = 1;
      this.changePic();
    },
    changeRight() {
      if (this.picIndex < 13) {
        this.picIndex++;
        document.getElementById("rightClick").style.opacity = 1;
      } else {
        this.picIndex = 13;
        document.getElementById("rightClick").style.opacity = 0.4;
      }
      document.getElementById("leftClick").style.opacity = 1;
      this.changePic();
    },
    changePic() {
      if (this.picIndex == 2) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/411.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/412.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/413.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/414.jpg");
      } else if (this.picIndex == 3) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/412.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/413.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/414.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/415.jpg");
      } else if (this.picIndex == 4) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/413.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/414.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/415.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/416.jpg");
      } else if (this.picIndex == 5) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/414.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/415.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/416.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/417.jpg");
      } else if (this.picIndex == 6) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/415.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/416.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/417.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/418.jpg");
      } else if (this.picIndex == 7) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/416.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/417.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/418.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/419.jpg");
      } else if (this.picIndex == 8) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/417.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/418.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/419.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4110.jpg");
      } else if (this.picIndex == 9) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/418.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/419.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/4110.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4111.jpg");
      } else if (this.picIndex == 10) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/419.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/4110.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/4111.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4112.jpg");
      } else if (this.picIndex == 11) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/4110.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/4111.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/4112.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4113.jpg");
      } else if (this.picIndex == 12) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/4111.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/4112.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/4113.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4114.jpg");
      } else if (this.picIndex == 13) {
        this.imgData.type = 0;
        this.imgData.url1 = require("../../assets/viloran-drive/imgs/4112.jpg");
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/4113.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/4114.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/4115.jpg");
      } else if (this.picIndex == 1) {
        this.imgData.type = 2;
        this.imgData.url1 = require("../../static/viloran-drive/video/404.jpg");
        this.imgData.video1 = viloran_dirve_402;
        this.imgData.url2 = require("../../assets/viloran-drive/imgs/411.jpg");
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/412.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/413.jpg");
      } else if (this.picIndex == 0) {
        this.imgData.type = 1;
        this.imgData.url1 = require("../../static/viloran-drive/video/403.jpg");
        this.imgData.video1 = viloran_dirve_401;
        this.imgData.url2 = require("../../static/viloran-drive/video/404.jpg");
        this.imgData.video2 = viloran_dirve_402;
        this.imgData.url3 = require("../../assets/viloran-drive/imgs/411.jpg");
        this.imgData.url4 = require("../../assets/viloran-drive/imgs/412.jpg");
      }
    },
    showPop(url) {
      this.showCover = true;
      this.popUrl = url;
      document.getElementsByTagName("html")[0].style.height = "100%";
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
      this.getPopPicIndex(url);
    },
    closePop() {
      this.showCover = false;
      document.getElementsByTagName("html")[0].style.height = "";
      document.getElementsByTagName("html")[0].style.overflow = "";
    },
    playVideo1(imgData) {
      this.popUrl = null;
      this.showCover = true;
      if (this.picIndex == 0) {
        this.videoUrl = this.imgData.video1;
      } else if (this.picIndex == 1) {
        this.videoUrl = this.imgData.video2;
      }
      this.getPopPicIndex(this.videoUrl);
      document.getElementsByTagName("html")[0].style.height = "100%";
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
    },
    playVideo2(imgData) {
      this.popUrl = null;
      this.showCover = true;
      this.videoUrl = this.imgData.video2;
      this.getPopPicIndex(this.videoUrl);
      document.getElementsByTagName("html")[0].style.height = "100%";
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
    },
    getPopPicIndex(url) {
      // 根据url比对出index
      this.popPicIndex = 1;
      for (let item of this.popPicArr) {
        if (url == item.url) {
          this.popPicIndex = item.popPicIndex;
        }
      }
    },
    changeLeftPop() {
      if (this.popPicIndex > 1) {
        this.popPicIndex--;
        document.getElementById("leftClickPop").style.opacity = 1;
      } else {
        this.popPicIndex = 1;
        document.getElementById("leftClickPop").style.opacity = 0.4;
      }
      document.getElementById("rightClickPop").style.opacity = 1;
      this.changePopPic();
    },
    changeRightPop() {
      if (this.popPicIndex < 17) {
        this.popPicIndex++;
        document.getElementById("rightClickPop").style.opacity = 1;
      } else {
        this.popPicIndex = 17;
        document.getElementById("rightClickPop").style.opacity = 0.4;
      }
      document.getElementById("leftClickPop").style.opacity = 1;
      this.changePopPic();
    },
    changePopPic() {
      if (this.popPicIndex == 1) {
        this.popUrl = "../../static/viloran-drive/video/403.jpg";
        this.videoUrl = null;
        setTimeout(() => {
          this.popUrl = null;
          this.videoUrl = viloran_dirve_401;
        }, 10);
      } else if (this.popPicIndex == 2) {
        this.popUrl = "../../static/viloran-drive/video/404.jpg";
        this.videoUrl = null;
        setTimeout(() => {
          this.popUrl = null;
          this.videoUrl = viloran_dirve_402;
        }, 10);
      } else if (this.popPicIndex == 3) {
        this.popUrl = require("../../assets/viloran-drive/imgs/411.jpg");
      } else if (this.popPicIndex == 4) {
        this.popUrl = require("../../assets/viloran-drive/imgs/412.jpg");
      } else if (this.popPicIndex == 5) {
        this.popUrl = require("../../assets/viloran-drive/imgs/413.jpg");
      } else if (this.popPicIndex == 6) {
        this.popUrl = require("../../assets/viloran-drive/imgs/414.jpg");
      } else if (this.popPicIndex == 7) {
        this.popUrl = require("../../assets/viloran-drive/imgs/415.jpg");
      } else if (this.popPicIndex == 8) {
        this.popUrl = require("../../assets/viloran-drive/imgs/416.jpg");
      } else if (this.popPicIndex == 9) {
        this.popUrl = require("../../assets/viloran-drive/imgs/417.jpg");
      } else if (this.popPicIndex == 10) {
        this.popUrl = require("../../assets/viloran-drive/imgs/418.jpg");
      } else if (this.popPicIndex == 11) {
        this.popUrl = require("../../assets/viloran-drive/imgs/419.jpg");
      } else if (this.popPicIndex == 12) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4110.jpg");
      } else if (this.popPicIndex == 13) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4111.jpg");
      } else if (this.popPicIndex == 14) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4112.jpg");
      } else if (this.popPicIndex == 15) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4113.jpg");
      } else if (this.popPicIndex == 16) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4114.jpg");
      } else if (this.popPicIndex == 17) {
        this.popUrl = require("../../assets/viloran-drive/imgs/4115.jpg");
      }
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 1px) {
  .clickStyle {
    cursor: pointer;
  }
  .container1 {
    width: 100%;
  }
  .container1 .video {
    width: 100%;
  }

  .container2 {
    margin-top: 135px;
    padding: 0 160px;
  }
  .container2 .content {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .container2 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .left .img {
    margin-left: 40px;
    margin-right: 40px;
    -webkit-transform: translate(0px, -64px);
    -moz-transform: translate(0px, -64px);
    transform: translate(0px, -64px);
  }
  .container2 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .right .title {
    font-size: 30px;
    line-height: 24px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 170px;
  }
  .container2 .content .right .line {
    width: 60px;
    height: 0px;
    border-bottom: solid 4px black;
    margin-top: 27px;
  }
  .container2 .content .right .text {
    font-size: 16px;
    line-height: 32px;
    color: rgba(51, 51, 51, 1);
    margin-top: 40px;
  }
  .container2 .spot1 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 45%;
    cursor: pointer;
  }
  .container2 .spot2 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 50%;
    cursor: pointer;
  }
  .container2 .spot3 {
    position: absolute;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 100%;
    bottom: 20%;
    left: 55%;
    cursor: pointer;
  }
  .container3 {
    position: relative;
    background-image: url("../../assets/viloran-drive/imgs/301.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 100px;
    padding-top: 60px;
    padding-bottom: 148px;
  }
  .container3 .title .img {
    position: relative;
    width: 226px;
    left: 50%;
    margin-left: -113px;
  }
  .container3 .content {
    position: relative;
    margin-top: 85px;
  }
  .container3 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .left .contain {
    height: 500px;
    margin-left: 160px;
    margin-right: 55px;
    overflow-y: auto;
  }
  /*.container3 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: #535353;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: #ededed;*/
  /*}*/
  .container3 .content .left .contain .list {
    margin-right: 60px;
  }
  .container3 .content .left .contain .item {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .container3 .content .left .contain .item:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  .container3 .content .left .contain .item .title {
    width: 118px;
  }
  .container3 .content .left .contain .item .text {
    margin-top: 10px;
    font-size: 16px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }
  .container3 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .right .img {
    margin-right: 160px;
  }
  .container3 .jumpWei {
    margin-top: 10px;
    width: 120px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 16px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .container4 {
    position: relative;
    margin-top: 100px;
    padding-bottom: 148px;
    padding-left: 100px;
    padding-right: 100px;
  }
  .container4 .title .img {
    position: relative;
    width: 226px;
    left: 50%;
    margin-left: -113px;
  }
  .container4 .content {
    position: relative;
    width: 100%;
    margin-top: 60px;
  }

  .container4 .content table {
    position: relative;
    width: 100%;
  }
  .container4 .content td {
    text-align: center;
  }
  .container4 .content .img {
    text-align: center;
    padding: 0 15px;
  }
  .container4 .content .left {
    position: absolute;
    top: 40%;
    left: 30px;
    width: 30px;
  }
  .container4 .content .right {
    position: absolute;
    top: 40%;
    right: 30px;
    width: 30px;
  }
  .container4 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .container4 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 800px;
    height: 571.4px;
  }
  .container4 .popup .close {
    position: relative;
    float: right;
    width: 20px;
    cursor: pointer;
  }
  .container4 .popup .left {
    position: absolute;
    top: 50%;
    left: 2%;
  }
  .container4 .popup .right {
    position: absolute;
    top: 50%;
    right: 2%;
  }
}
@media screen and (min-width: 1px) and (max-width: 1300px) {
  .clickStyle {
    cursor: pointer;
  }
  .container1 {
    width: 100%;
  }
  .container1 .video {
    width: 100%;
  }

  .container2 {
    margin-top: 91px;
    padding: 0 160px;
  }
  .container2 .content {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .container2 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .left .img {
    margin-left: 27px;
    margin-right: 27px;
    -webkit-transform: translate(0px, -43px);
    -moz-transform: translate(0px, -43px);
    transform: translate(0px, -43px);
  }
  .container2 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .right .title {
    font-size: 20px;
    line-height: 16px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 80px;
  }
  .container2 .content .right .line {
    width: 60px;
    height: 0px;
    border-bottom: solid 4px black;
    margin-top: 18px;
  }
  .container2 .content .right .text {
    font-size: 12px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-top: 26px;
  }
  .container3 {
    position: relative;
    background-image: url("../../assets/viloran-drive/imgs/301.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 61px;
    padding-top: 40px;
    padding-bottom: 100px;
  }
  .container3 .title .img {
    position: relative;
    width: 154px;
    left: 50%;
    margin-left: -77px;
  }
  .container3 .content {
    position: relative;
    margin-top: 58px;
  }
  .container3 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .left .contain {
    height: 325px;
    margin-left: 110px;
    margin-right: 36px;
    overflow-y: auto;
  }
  /*.container3 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: #535353;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: #ededed;*/
  /*}*/
  .container3 .content .left .contain .list {
    margin-right: 60px;
  }
  .container3 .content .left .contain .item {
    width: 100%;
    margin-bottom: 11px;
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .container3 .content .left .contain .item .title {
    width: 80px;
  }
  .container3 .content .left .contain .item .text {
    margin-top: 5px;
    font-size: 12px;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
  }
  .container3 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .right .img {
    margin-right: 110px;
  }
  .container3 .jumpWei {
    margin-top: 5px;
    width: 80px;
    height: 20px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 12px;
    line-height: 22px;
    color: rgba(255, 255, 255, 1);
  }

  .container4 {
    position: relative;
    margin-top: 68px;
    padding-bottom: 100px;
    padding-left: 60px;
    padding-right: 60px;
  }
  .container4 .title .img {
    position: relative;
    width: 154px;
    left: 50%;
    margin-left: -77px;
  }
  .container4 .content {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }

  .container4 .content table {
    position: relative;
    width: 100%;
  }
  .container4 .content td {
    text-align: center;
  }
  .container4 .content .img {
    text-align: center;
    padding: 0 4px;
  }
  .container4 .content .left {
    position: absolute;
    top: 40%;
    left: 20px;
    width: 20px;
  }
  .container4 .content .right {
    position: absolute;
    top: 40%;
    right: 20px;
    width: 20px;
  }
  .container4 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .container4 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 600px;
    height: 428.6px;
  }
  .container4 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .clickStyle {
    cursor: pointer;
  }
  .container1 {
    width: 100%;
  }
  .container1 .video {
    width: 100%;
  }

  .container2 {
    margin-top: 113px;
    padding: 0 133px;
  }
  .container2 .content {
    position: relative;
    background: rgba(243, 243, 243, 1);
  }
  .container2 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .left .img {
    margin-left: 33px;
    margin-right: 33px;
    -webkit-transform: translate(0px, -53px);
    -moz-transform: translate(0px, -53px);
    transform: translate(0px, -53px);
  }
  .container2 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container2 .content .right .title {
    font-size: 25px;
    line-height: 20px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 100px;
  }
  .container2 .content .right .line {
    width: 60px;
    height: 0px;
    border-bottom: solid 4px black;
    margin-top: 18px;
  }
  .container2 .content .right .text {
    font-size: 13px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    margin-top: 33px;
  }
  .container3 {
    position: relative;
    background-image: url("../../assets/viloran-drive/imgs/301.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 83px;
    padding-top: 50px;
    padding-bottom: 123px;
  }
  .container3 .title .img {
    position: relative;
    width: 188px;
    left: 50%;
    margin-left: -94px;
  }
  .container3 .content {
    position: relative;
    margin-top: 71px;
  }
  .container3 .content .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .left .contain {
    height: 430px;
    margin-left: 134px;
    margin-right: 44px;
    overflow-y: auto;
  }
  /*.container3 .content .left .contain::-webkit-scrollbar {*/
  /*  !*滚动条整体样式*!*/
  /*  width: 4px; !*高宽分别对应横竖滚动条的尺寸*!*/
  /*  height: 1px;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-thumb {*/
  /*  !*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  background: #535353;*/
  /*}*/
  /*.container3 .content .left .contain::-webkit-scrollbar-track {*/
  /*  !*滚动条里面轨道*!*/
  /*  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
  /*  border-radius: 10px;*/
  /*  background: #ededed;*/
  /*}*/
  .container3 .content .left .contain .list {
    margin-right: 44px;
  }
  .container3 .content .left .contain .item {
    width: 100%;
    margin-bottom: 14px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .container3 .content .left .contain .item .title {
    width: 80px;
  }
  .container3 .content .left .contain .item .text {
    margin-top: 10px;
    font-size: 13px;
    line-height: 27px;
    color: rgba(255, 255, 255, 1);
  }
  .container3 .content .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .container3 .content .right .img {
    margin-right: 133px;
  }
  .container3 .jumpWei {
    margin-top: 10px;
    width: 100px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid rgba(245, 245, 245, 1);
    font-size: 13px;
    line-height: 27px;
    color: rgba(255, 255, 255, 1);
  }

  .container4 {
    position: relative;
    margin-top: 83px;
    padding-bottom: 124px;
    padding-left: 90px;
    padding-right: 90px;
  }
  .container4 .title .img {
    position: relative;
    width: 188px;
    left: 50%;
    margin-left: -94px;
  }
  .container4 .content {
    position: relative;
    width: 100%;
    margin-top: 50px;
  }

  .container4 .content table {
    position: relative;
    width: 100%;
  }
  .container4 .content td {
    text-align: center;
  }
  .container4 .content .img {
    text-align: center;
    padding: 0 5px;
  }
  .container4 .content .left {
    position: absolute;
    top: 40%;
    left: 20px;
    width: 25px;
  }
  .container4 .content .right {
    position: absolute;
    top: 40%;
    right: 20px;
    width: 25px;
  }
  .container4 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .container4 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 700px;
    height: 500px;
  }
  .container4 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
</style>